import { z } from "zod";

export enum AuthMessage {
  MALFORMED_EMAIL = 'email is malformed',
  USER_DOES_NOT_EXIST = 'this email does not exist',
  INVALID_CREDENTIALS = 'email or password invalid',
  ACCOUNT_DEACTIVATED = 'this account is deactivated',
  ACCOUNT_NOT_ACTIVE = 'this account is not active',
  TOO_MANY_ATTEMPTS = 'too many attempts',
  EMAIL_ALREADY_EXISTS = 'this email already exists',
  PASSWORD_TOO_SHORT = 'password must be at least 8 letters long',
  INVALID_TIMEZONE = 'timezone is not supported',
  TOKEN_EXPIRED = 'token is expired',
  INVALID_TOKEN = 'token is invalid',
  INVALID_PASSWORD = 'current password is invalid',
  PASSWORD_MISMATCH = 'passwords do not match',
  EMAIL_REQUIRED = 'email is required',
  PASSWORD_REQUIRED = 'password is required',
  TOKEN_REQUIRED = 'token is required',
  INVALID_FIRSTNAME = 'first Name is not valid',
  FIRSTNAME_REQUIRED = 'first Name is required',
  INVALID_LASTNAME = 'last Name is not valid',
  LASTNAME_REQUIRED = 'last Name is required',
  INVALID_ORGANIZATION_NAME = 'organization name is invalid',
  CURRENT_PASSWORD_INVALID = 'current Password is invalid',
  PASSWORD_RESET_SUCCESSFUL = 'Password Reset Successful',
  PASSWORD_RESET_LINK_SENT = 'Reset Link Sent',
  INTERNAL_SERVER_ERROR = 'Internal server error',
  UNABLE_TO_FETCH = 'Unable to fetch from API',
  PASSWORD_RESET_TOKEN_VERIFICATION_FAILED = 'Token verification failed',
  INVITATION_ACCEPTED = 'Invitation Accepted.',
  INVITATION_ERROR = 'An Error occured while accepting the invite.'
}

export const AuthSchema = {
  login: z.object({
    email: z.string().email(),
    password: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    })
  }),
  signup: z.object({
    email: z.string().email(),
    password: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    confirmPassword: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    firstName: z.string().min(3, {
      message: 'First Name must be at least 3 characters.'
    }),
    lastName: z.string().min(3, {
      message: 'Last Name must be at least 3 characters.'
    }),
    phone: z.string().optional(),
    organization: z.string().optional(),
    timezone: z.string().optional(),
    agreeTerms: z.boolean().refine(value => value, {
      message: 'Please agree to our Terms and Conditions.'
    })
  }),
  forgotPassword: z.object({
    email: z.string().email()
  }),
  resetPasswordEmailVerification: z.object({
    email: z.string().email(),
  }),
  resetPasswordConfirm: z.object({
    newPassword: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    confirmNewPassword: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    })
  }),
  acceptInviteForm: z.object({
    password: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    confirmPassword: z.string().min(8, {
      message: 'Password must be at least 8 characters.'
    }),
    firstName: z.string().min(3, {
      message: 'First Name must be at least 3 characters.'
    }),
    lastName: z.string().min(3, {
      message: 'Last Name must be at least 3 characters.'
    }),
    phone: z.string().optional(),
    timezone: z.string().optional(),
    agreeTerms: z.boolean().refine(value => value, {
      message: 'Please agree to our Terms and Conditions.'
    })
  })
}
